import { Compass } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";

export function NotFoundView() {
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <EmptyState
        icon={Compass}
        title="Página não encontrada"
        description="O link pode estar errado. Use o link que seu treinador enviou."
      />
    </div>
  );
}
